import React from "react";

import IntersectionObserver from "@is/components/IntersectionObserver";
import { ContentItem } from "@is/types";

import css from "./ContentItemComponent.module.css";
import useManageContentItemComponent from "./hooks/useManageContentItemComponent";

type Props = {
  item: ContentItem;
  itemIndex: number;
  contentItemsRefs?: React.RefObject<Record<string, HTMLDivElement>>;
  contentItemsAnchorRefs?: React.RefObject<Record<string, HTMLDivElement>>;
  searchDrawerHeight?: number;
  sectionId: string;
  setShowGoToBottomButton?: React.Dispatch<React.SetStateAction<boolean>>;
  handleShowMore?: () => void;
};

const ContentItemComponent = ({
  item,
  itemIndex,
  contentItemsRefs,
  searchDrawerHeight,
  sectionId,
  contentItemsAnchorRefs,
  setShowGoToBottomButton,
  handleShowMore,
}: Props) => {
  const {
    handleIntersectedItemsIdsUpdate,
    handleLastIntersectedItem,
    itemOffset,
    content,
    bestMatchMessage,
  } = useManageContentItemComponent({
    item,
    itemIndex,
    searchDrawerHeight,
    sectionId,
    setShowGoToBottomButton,
    handleShowMore,
  });

  return (
    <IntersectionObserver
      className={css.container}
      onUpdate={handleIntersectedItemsIdsUpdate}
      onLastIntersectedItem={handleLastIntersectedItem}
    >
      <div
        ref={(ref) => {
          contentItemsRefs.current[item.id] = ref;
        }}
        style={{
          position: "relative",
          top: itemOffset,
        }}
      />

      {bestMatchMessage}

      {content}

      <div
        ref={(ref) => {
          contentItemsAnchorRefs.current[item.id] = ref;
        }}
      />
    </IntersectionObserver>
  );
};

export default ContentItemComponent;
